/**
 * @author HungNS
 */
import BaseService from "./BaseService";
import {ROOT, PROFILE, ACCOUNT, SYSTEM} from "./_base";

class ForceNewsService extends BaseService {

    async loadSystemCache(params = {}) {
        const response = await this.get(`${ROOT}/${SYSTEM}/load-cache`, params);
        return response.data;
    }

    async getAmsCustomerInfo(params = {}) {
        const response = await this.get(`${ROOT}/${PROFILE}/get-ams-customer-info`, params);
        return response.data;
    }

    async searchZipCode(params = {}) {
        const response = await this.get(`${ROOT}/${PROFILE}/search-zipcode`, params);
        return response.data;
    }

    async updateCustomerInfo(data, config) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/update-customer-info`, data, config)
        return response;
    }

    async saveForceNews(config = {}) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/save-force-news`, config);
        return response;
    }


}

export default ForceNewsService;